// 知识产权相关路由配置 3.17.0
const zscqRouterConfigs = [
  {
    path: '/zscqProductList',
    name: 'zscqProductList',
    meta: { routeName: '知识产权产品列表' },
    component: () => import('@/views/zscqPage/productList')
  },
  {
    path: '/zscqOrderList',
    name: 'zscqOrderList',
    meta: { routeName: '知识产权订单列表' },
    component: () => import('@/views/zscqPage/orderList')
  },
  {
    path: '/zscqOrderDetail',
    name: 'zscqOrderDetail',
    meta: { routeName: '知识产权订单详情' },
    component: () => import('@/views/zscqPage/orderDetail')
  }
]

export default zscqRouterConfigs
